import React, { Component } from 'react';
import { connect } from 'react-redux';
// import _ from 'lodash';
import BRSpan from '../../General/BRSpan';
// import Slider from 'react-slick';
//import { videoType } from '../../utils/fileHelpers';
import FontAwesome from 'react-fontawesome';
import ReactPlayer from 'react-player';

const backSvg = require('../../../../public/img/ui/back.svg');
const forwardSvg = require('../../../../public/img/ui/forward.svg');
const closeSvg = require('../../../../public/img/ui/close.svg');

class StoryChicago extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSlide: 0,
      videoPlaying: new Array(this.props.slickAssets.length),
      slideChanging: false
    };

    this._videoStyle = {
      preload: 'auto',
      objectFit: 'contain',
      width: this.props.width / 2,
      height: this.props.width / 2,
      loop: '',
      autoplay: "",
      muted: "",
      pointerEvents: "none"
    };

    this._imageStyle = {
      objectFit: 'contain',
      width: this.props.width / 2,
      height: this.props.width / 2
    };

    this._videoRefs = new Array(this.props.slickAssets.length);
    this._slickRef = null;

    this._quoteClass = this.props.fontClass ? this.props.fontClass + " aligner" : "aligner aleo-bolditalic";
    this._bodyClass = this.props.fontClass ? this.props.fontClass : "aleo-light";
    this._subtitleClass = this.props.fontClass ? this.props.fontClass : "ostrich-medium";
    this._headlineClass = this.props.fontClass ? this.props.fontClass : "ostrich";
    this._contextualHeaderClass = this.props.fontClass ? this.props.fontClass + " valigner" : "ostrich-medium valigner";

  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "a":
        break;
      default:
        break;
    }
  }


  contextualheader() {
    let contextualheaderOuter = {
      borderRadius: this.props.screen.r16_9.p10 * 0.6,
      marginLeft: this.props.width / 40,
      backgroundColor: '#E5F5F6',
      height: this.props.height * 0.05,
      display: 'inline-flex',
      alignItems: "center"
    };

    let contextualheaderInner = {
      marginLeft: this.props.screen.r16_9.p10 * 0.2,
      marginRight: this.props.screen.r16_9.p10 * 0.1,
      color: "#424958",
      fontSize: this.props.height * 0.03, //this.props.width / 60,
      letterSpacing: 2,
    };

    return (
      <div style={contextualheaderOuter} className={this._contextualHeaderClass}>
        <span style={contextualheaderInner} className="valigner-item"><b>{this.props.contextualheader}</b></span> :
      </div>
    )
  }

  //String(this.props.screen.r16_9.p10*.6) + "px"
  headline() {
    return (
      <div className={this._headlineClass} style={{ color: "#424958", lineHeight: String(this.props.screen.r16_9.p10 * .6) + "px", fontSize: this.props.screen.r16_9.p10 * .6, paddingLeft: this.props.width / 40, width: this.props.width / 2.2 }}>
        <BRSpan preWrap str={this.props.headline} />
      </div>
    )
  }

  subtitle() {
    return (
      <div className={this._subtitleClass} style={{ color: "#424958", letterSpacing: 2, fontSize: this.props.width / 60, paddingLeft: this.props.width / 40, width: this.props.width / 2.2 }}>
        <span><b><BRSpan preWrap str={this.props.subtitle} /></b></span>
      </div>
    )
  }

  body() {
    if (this.props.useWYSIWYG) {
      let bodyClass = this._bodyClass + " ql-editor";
      return (
        <div className={bodyClass} dangerouslySetInnerHTML={{ __html: this.props.body }} style={{ fontSize: this.props.screen.r16_9.p10 * .18, paddingLeft: this.props.width / 40, columnCount: 2, color: "#424958", lineHeight: String(this.props.screen.r16_9.p10 * .25) + "px", position: 'absolute', width: this.props.width / 2.2 }}/>
      )
    } else {
      return (
        <div className={this._bodyClass} style={{ fontSize: this.props.screen.r16_9.p10 * .18, paddingLeft: this.props.width / 40, columnCount: 2, color: "#424958", lineHeight: String(this.props.screen.r16_9.p10 * .25) + "px", position: 'absolute', width: this.props.width / 2.2 }}>
          {this.props.body ?
            <span><BRSpan preWrap str={this.props.body} /></span> :
            <span></span>}
        </div>
      )
    }
  }

  quote() {
    let divStyle = {display: 'flex', justifyContent: 'center', fontSize: this.props.screen.r16_9.p10 * .2, lineHeight: String(this.props.screen.r16_9.p10 * .3) + "px", color: "#424958", width: this.props.width / 3, height: this.props.height * .10, fontWeight: 'bold', textAlign: 'center'}
    if (this.props.showQuotes===true){
      divStyle.backgroundImage = "url(img/chicago/quotes.png)";
      divStyle.backgroundSize = '100% 100%'; 
      divStyle.backgroundRepeat = 'no-repeat';
    }
    return (
      <div>
        {this.props.quote ?
          <div style={{ width: '100%', textAlign: 'center' }}>
            {/* {this.props.showQuotes===true? } */}
            {/* backgroundImage: "url(img/chicago/quotes.png)", backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' */}
            <div className={this._quoteClass} style={divStyle}>
              <BRSpan preWrap str={this.props.quote} />
            </div>
          </div>
          :
          <span />
        }
      </div>
    )
  }

  navarea() {
    return (
      <div style={{ position: 'absolute', width: this.props.width, height: this.props.height - this.props.width / 2, bottom: 0, backgroundColor: '#424958' }}>
        <div style={{ display: 'inline-flex', alignItems: "center", width: '100%', height: '100%' }}>
          <span style={{ width: '50%' }}>
            <img alt="back" onClick={() => this.props.cycleStory("backward")} style={{ marginLeft: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .024 }} src={backSvg} />
            <img alt="forward" onClick={() => this.props.cycleStory("forward")} style={{ marginLeft: this.props.width * .03, width: this.props.width * .024, height: this.props.width * .024 }} src={forwardSvg} />
          </span>
          <span style={{ width: '50%', textAlign: 'right' }}>
            <img alt="close" onClick={() => this.close()} style={{ marginRight: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .04 }} src={closeSvg} /></span>
        </div>
      </div>
    )
  }

  close() {
    this.props.closeStory();
  }

  playVideo = () => {
    let videoPlaying = this.state.videoPlaying;
    videoPlaying[this.state.selectedSlide] = true;
    this.setState({
      videoPlaying: videoPlaying
    })
    //console.log("playing video");
  }

  stopVideo = () => {
    let videoPlaying = this.state.videoPlaying;
    videoPlaying[this.state.selectedSlide] = false;
    this.setState({
      videoPlaying: videoPlaying
    })
    //console.log("stopping video");
  }

  renderSlickAssets = () => {
    if (!this.props.slickAssets || this.props.slickAssets.length===0){
      return (
        <div />
      )
    }
    //console.log("SLICK ASSETS", this.props.slickAssets)
    //={this.state.videoPlaying[i]}
    //let iconStyle = { zIndex: 1000, fontSize: this.props.screen.screenHeight * .1, color: 'rgba(0,0,0, .5' }
    //console.log(this.props.slickAssets);
    return (
      this.props.slickAssets.map(function (row, i) {
          switch (row.fileType) {
            case "Video":
              return (
                // <video key={i} className="nodrag" style={this._videoStyle} id={"background-video-"+i} controls muted>
                //   <source src={row.path} type={row.videoType} />
                //   Your browser does not support the video tag.
                // </video>
                <div  key={i}>
                <div onMouseDown={this.videoClicked} style={{ Display: 'flex' }}>
                  <div className="valigner" style={{ position: 'inline-block', width: this.props.width / 2, height: this.props.width / 2 }}>
                    <div className="valigner-item" style={{ position: 'inline-block', width: this.props.width / 2 }}>
                      <ReactPlayer onEnded={this.videoEnded} ref={el => this._videoRefs[i] = el} key={i} url={row.path} width={this.props.width / 2} height={this.props.width / 2} playing={this.state.videoPlaying[i]} loop={false} />
                    </div>
                  </div>
                </div>
                {(this.getIsVideoSlide() && !this.getVideoIsPlaying() && !this.state.slideChanging) ?
              <div style={{ display: 'flex' }}>
                <div onMouseDown={this.playVideo} className="valigner" style={{ width: this.props.width / 2, height: this.props.width / 2, position: 'absolute', bottom: 0, alignItems: 'center', justifyContent: 'center' }}>
                    <div className="valigner-item">
                        <span className="phand"><FontAwesome style={{fontSize: this.props.width / 8, opacity: .75}} name='play-circle' /></span>
                    </div>
                </div>
              </div>
              :
              null
              }
                </div>

              )
            case "Image":
            default:
              return (
                <span key={i}>
                  <img alt="Detail" style={this._imageStyle} src={row.path} />
                </span>
              )
          }
      }, this)
    )
  }

  goToSlide = (slide) => {
    this._slickRef.slickGoTo(slide)
  }

  nextSlide = () => {
    this._slickRef.slickNext()
  }

  lastSlide = () => {
    this._slickRef.slickPrev()
  }

  slideChanged = (slide) => {
    let videoPlaying = this.state.videoPlaying;
    for (var i = 0; i < videoPlaying.length; i++) {
      videoPlaying[i] = false;

      if (this._videoRefs[this.state.selectedSlide]){ //seek previouse slide to 0
        this._videoRefs[this.state.selectedSlide].seekTo(0)
      }
    }
    // if (this._videoRefs[slide]) {
    //   this._videoRefs[slide].seekTo(0)
    // }
    this.setState({
      videoPlaying: videoPlaying,
      selectedSlide: slide,
      slideChanging: false
    })
  }

  videoClicked = () => {
    if (this.getIsVideoSlide() && this.getVideoIsPlaying()){
      this.stopVideo();
    }
  }

  videoEnded = () => {
    if (this._videoRefs[this.state.selectedSlide]){
      this._videoRefs[this.state.selectedSlide].seekTo(0)
    }
    this.stopVideo();
  }

  getIsVideoSlide = () => {
    return this.props.slickAssets[this.state.selectedSlide].fileType==="Video";
  }
  getVideoIsPlaying = () => {
    return this.state.videoPlaying[this.state.selectedSlide];
  }

  renderCycleButtons = (blockWidth) => {
    let bdist = this.props.screen.r16_9.p10 * 0.75;
    let halflength = ((this.props.slickAssets.length * bdist) / 2);
    let leftStart = (blockWidth / 2) - halflength;//+ this.props.screen.screenHeight * .0185;
    let iconStyle = { zIndex: 1000, fontSize: this.props.screen.screenHeight * .04, color: 'rgba(0,0,0, .5' }
    let iconStyleActive = { zIndex: 1000, fontSize: this.props.screen.screenHeight * .04, color: 'rgba(0,0,0, .9' }
    let spanclass = "fadediv"
    let iconOffsetY = this.props.height*.0075;
    let backdropStyle = {
      pointerEvents: 'none',
      borderRadius: this.props.screen.r16_9.p10 * 0.6,
      backgroundColor: 'white',
      opacity: 0.5,
      display: 'inline-block',
      position: 'absolute',
      left: this.props.width/4 - (((this.props.slickAssets.length+2)/2) * bdist) - this.props.screen.screenHeight * .02,
      width: (this.props.slickAssets.length+2) * bdist, //+ 2 for end arrows
      height: this.props.screen.screenHeight * .06
    }

    //TODO: convert this to a component and share with story!!!
    if (this.props.slickAssets.length < 2) {
      return null;
    }
    return (
      this.props.slickAssets.map(function (row, i) {
        let iStyle = iconStyle;
        if (i === this.state.selectedSlide) {
          iStyle = iconStyleActive;
        }
        // left button and first entry
        if (i === 0) {
          return (
            <span key={i} className={spanclass}>
              <span style={backdropStyle}/>
              <span onMouseDown={() => this.lastSlide()} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (-1 * bdist), top: iconOffsetY }}>
                <span className="phand" style={iconStyle}><FontAwesome name='arrow-circle-left' /></span>
              </span>
              <span onMouseDown={() => this.goToSlide(i)} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (i * bdist), top: iconOffsetY }}>
                <span className="phand" style={iStyle}><FontAwesome name='circle' /></span>
              </span>
            </span>
          )
        }
        // second to last and last entry
        else if (i === this.props.slickAssets.length - 1) {
          return (
            <span key={i} className={spanclass}>
              {/* {this.props.slickAssets.length>} */}
              <span onMouseDown={() => this.goToSlide(i)} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (i * bdist), top: iconOffsetY }}>
                <span className="phand" style={iStyle}><FontAwesome name='circle' /></span>
              </span>
              <span onMouseDown={() => this.nextSlide()} style={{ textAlign: 'center', position: 'absolute', left: leftStart + ((i + 1) * bdist), top: iconOffsetY }}>
                <span className="phand" style={iconStyle}><FontAwesome name='arrow-circle-right' /></span>
              </span>
            </span>
          )
        }
        // middle entry
        else {
          return (
            <span key={i} className={spanclass} onMouseDown={() => this.goToSlide(i)} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (i * bdist), top: iconOffsetY }}>
              <span className="phand" style={iStyle}><FontAwesome name='circle' /></span>
            </span>
          )
        }
      }, this)
    )
  }

  render() {

    // let contextualheader = this.contextualheader()
    // let headline = this.headline()
    // let subtitle = this.subtitle()
    // let body = this.body()
    let navarea = this.navarea()
    // let quote = this.quote()

    // var settings = {
    //   dots: false,
    //   arrows: false,
    //   infinite: false,
    //   speed: 500,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   centerMode: false,
    //   useCSS: true,
    //   afterChange: (currentSlide) => {
    //     this.slideChanged(currentSlide);
    //   },
    // };

    return (
      <div style={{ pointerEvents: 'auto', position: 'absolute', left: this.props.left, width: this.props.width, height: this.props.height, top: this.props.top, backgroundColor: 'white' }}>
        <div style={{ position: "relative", width: this.props.width, height: this.props.height, backgroundColor: 'white' }}>
          <div style={{ background: "url("+ this.props.mainimage +")", height: "96%", width: "100%", backgroundSize:"contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}></div>


          <div style={{ zIndex: 500, position: 'absolute', top: 0, left: 0, width: this.props.width / 2, height: this.props.width / 2 }}>
            {/* <img alt="Detail" style={this._imageStyle} src={this.props.mainimage}/> */}
            <div style={{ position: 'relative' }}>
              {/* <Slider ref={el => this._slickRef = el} {...settings}>
                {this.renderSlickAssets()}
              </Slider> */}

              {/* Play indicator */}
              {/* {(this.getIsVideoSlide() && !this.getVideoIsPlaying() && !this.state.slideChanging) ?
              <div style={{ display: 'flex' }}>
                <div onMouseDown={this.playVideo} className="valigner" style={{ width: this.props.width / 2, height: this.props.width / 2, position: 'absolute', bottom: 0, alignItems: 'center', justifyContent: 'center' }}>
                    <div className="valigner-item">
                        <span className="phand"><FontAwesome style={{fontSize: this.props.width / 4}} name='play-circle' /></span>
                    </div>
                </div>
              </div>
              :
              null
              } */}


              <div style={{ width: this.props.width / 2, height: this.props.height * .075, position: 'absolute', bottom: this.props.height * .01 }}>
                {this.renderCycleButtons(this.props.width / 2)}
                {/* <div style={{position:'absolute', display: "inline-block", width: this.props.width/2, height: this.props.height*.1, backgroundColor: 'black', opacity: .5}} /> */}
              </div>
            </div>
            {/* <Slider {...settings}>
            <img alt="Detail" style={this._imageStyle} src={"img/ui/image_default.png"}/>
            <video className="nodrag" style={this._videoStyle} id="background-video" loop autoPlay muted>
              <source src={this.props.mainimage} type={"video/mp4"} />
              Your browser does not support the video tag.
            </video>
            <video className="nodrag" style={this._videoStyle} id="background-video2" loop autoPlay muted>
              <source src={this.props.mainimage} type={"video/mp4"} />
              Your browser does not support the video tag.
            </video>
            </Slider> */}

          </div>

          {/* <div style={{lineHeight: String(Math.floor(this.props.width / 2))+'px', textAlign: 'center', position: 'absolute', top:0, left: 0, width: this.props.width / 2, height: this.props.height-barheight }}>
            <img alt="Detail" style={{verticalAlign: 'middle', maxWidth: '100%', maxHeight: '100%'}} src={this.props.mainimage}/>
          </div> */}

          {/* <div style={{ position: 'absolute', width: this.props.width / 2, height: this.props.height, backgroundImage: 'url('+this.props.mainimage+')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} /> */}


          {/* <div style={{lineHeight: String(Math.floor(this.props.width / 2))+'px', textAlign: 'center', position: 'absolute', top:0, left: 0, width: this.props.width / 2, height: this.props.height-barheight }}>
            <img alt="Detail" style={{verticalAlign: 'middle', maxWidth: '100%', maxHeight: '100%'}} src={this.props.mainimage}/>
          </div> */}

          {/* <div style={{ position: 'absolute', left: this.props.width / 2, width: this.props.width / 2, height: this.props.height * .65 }}>
            <div style={{ position: 'relative' }}>
              <span style={{ display: 'inline-block', width: '100%', height: this.props.height * 0.0336 }} />
              {contextualheader}
              <span style={{ display: 'inline-block', width: '100%', height: this.props.height * 0.0336 }} />
              {headline}
              <span style={{ display: 'inline-block', width: '100%', height: this.props.height * 0.018 }} />
              {subtitle}
              <span style={{ display: 'inline-block', width: '100%', height: this.props.height * 0.0336 }} />
              {body}
            </div>
          </div>
          <div style={{ position: 'absolute', left: this.props.width / 2, width: this.props.width / 2, top: this.props.height * .73, height: this.props.height * .35 }}>
            <div style={{ position: 'relative' }}>
              <span style={{ backgroundColor: '#3a404e', display: 'inline-block', height: this.props.height * 0.0025, marginLeft: this.props.width / 40, width: this.props.width / 2.2 }} />
              <span style={{ display: 'inline-block', width: '100%', height: this.props.height * 0.025 }} />
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                {quote}
              </div>
            </div>
          </div> */}
        </div>
        {navarea}
      </div>

    )
  }
}

const mapStateToProps = (state) => {
  return {
    screen: state.screen,
  };
};

export default connect(mapStateToProps, null)(StoryChicago);



// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/StoryChicagoModal.js